module.exports = __webpack_public_path__ + "frontend/static/media/Toys.ba1e2ec4.png";